import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';

import { useAppSelector } from '@/redux/hooks';
import { getUrlFromPathname } from '@/redux/modules/config';
import { track } from '@/utils/amplitude/analytics/core';
import { TrackingPayload } from '@/utils/amplitude/analytics/core.types';
import { getAmplitudePageNameFromPath } from '@/utils/getPageNameFromPath';

type TrackPurchaseProtectionLearnMorePayload = TrackingPayload & {
    description: string;
};

const trackPurchaseProtectionLearnMoreAnalytics = (
    eventName: string,
    payload: TrackPurchaseProtectionLearnMorePayload
) => {
    track(eventName, payload);
};

export const useTrackPurchaseProtectionLearnMoreAnalytics = () => {
    const { pathname } = useLocation();
    const url = useAppSelector((state) => getUrlFromPathname(state, pathname));

    return useCallback(
        (eventName: string, { description }: Omit<TrackPurchaseProtectionLearnMorePayload, 'pageName' | 'url'>) => {
            trackPurchaseProtectionLearnMoreAnalytics(eventName, {
                description,
                pageName: getAmplitudePageNameFromPath(pathname),
                url,
            });
        },
        [pathname, url]
    );
};
